React = require 'react'
E = React.createElement
N = {}

{assign} = require 'lodash/object'

translations =
  disclaimer: "Disclaimer"
  disclaimerUrl: "http://www.willemot.eu/disclaimer/"

__ = (t) -> translations[t] || t

class Disclaimer extends React.Component
  render: ->
    E 'a',
      assign
        href: (__ "disclaimerUrl")
        target: '_blank'
        rel: "noopener noreferrer"
        @props
      (__ "disclaimer")

module.exports = Disclaimer



// WEBPACK FOOTER //
// ./components/disclaimer.coffee